import axios from 'axios'
// import Vue from 'vue'
import router from '../router'
import { Message } from 'element-ui'
let isShowModel = true
// 请求失败错误信息提示
// function checkCode (message) {
//   Vue.prototype.$msg(message, 'error')
// }

// 响应时间
// axios.defaults.timeout = 10000
// `withCredentails`选项表明了是否是跨域请求
axios.defaults.withCredentials = true

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL

// 添加请求拦截器
axios.interceptors.request.use(config => {
  const url = config.url
  const listUrl = ['/cms/cmsType/getAll']
  if (listUrl.includes(url)) {}
  if (window.sessionStorage.getItem('token')) {
    config.headers.Authorization = window.sessionStorage.getItem('token')
  }
  return config
}, error => {
  Promise.reject(error)
})

// 添加返回拦截器
axios.interceptors.response.use(response => {
  // 判断是不是 返回码000
  // 如果不是000  同意处理
  const { data } = response || {}
  const code = data.code
  const listCode = ['000', '904']
  if (typeof response !== 'undefined') {
    if (listCode.includes(code)) {
      // OK
      if (window.sessionStorage.getItem('token')) {
        isShowModel = true
      }
      return data
    } else {
      // 不是000
      // 文件下载
      const listUrl = ['/system/files/noAccessDownloadFile', '/system/w/downloadByPath', '/service/stTemplateFile/get', '/declare/i/xjwlsbMain/exportPdf', '/service/web/excel/template/respondent', '/service/i/web/stProjectAward/declare/generate/qrcode', '/service/i/web/personal/declare/generate/qrcode']
      if (listUrl.includes(response.config.url)) {
        return response
      } else {
        return Message.error(data.msg)
      }
    }
  }
}, error => {
  if (error && error.response) {
    switch (error.response.status) {
      case 400:
        error.message = '请求错误'
        break
      case 401:
        // 清空缓存，跳到登录界面
        localStorage.clear()
        sessionStorage.clear()
        if (error.response.data.msg) {
          // 账号或密码错误
          error.message = error.response.data.msg
        } else {
          // error.message = '登录过期，请重新登录1'
          if (window.location.pathname !== '/') {
            router.push({ path: '/login' })
          }
          if (isShowModel) {
            Message.error('登录过期，请重新登录')
            // ElMessage.error('登录过期，请重新登录')
            isShowModel = false
          }
          return false
        }
        break
      case 403:
        error.message = '拒绝访问'
        break
      case 404:
        error.message = '请求失败'
        break
      case 408:
        error.message = '请求超时'
        break
      case 500:
        error.message = '服务器内部错误'
        break
      case 501:
        error.message = '服务未实现'
        break
      case 502:
        error.message = '无法连接服务器'
        break
      case 503:
        error.message = '服务不可用'
        break
      case 504:
        error.message = '连接服务器超时'
        break
      case 505:
        error.message = 'HTTP版本不受支持'
        break
      default:
    }
  } else {
    // error.message = '无法连接服务器'
  }
  // 对返回的错误处理
  return Promise.reject(error)
})

export async function post (url, params, paramsA) {
  try {
    if (url == '/service/web/system/layout/get' || url == '/service/stTemplateFile/get' || url == '/service/stTemplateFile/getWebFiles' || url == '/service/stTemplateFile/getofficial' || url == '/service/web/batch/getBatchYears' || url == '/service/web/personage/getGenerate' || url == '/service/web/project/getGenerate' || url == '/service/web/confirm/getAllDetail' || url == '/service/web/confirm/getPath') {
    } else {
      const re = await axios.post('/service/web/system/layout/get')
      if (re.code == '000') {
        window.sessionStorage.setItem('projectState', re.result.projectState) // 项目奖添加申报按钮的显示
        window.sessionStorage.setItem('personalState', re.result.personalState) // 个人奖添加申报按钮的显示
        // window.sessionStorage.setItem('isExtendDataItem', re.result.isExtendDataItem) // 前台申报列表显示获奖状态栏
      }
      if (re.code == '000' && re.result.state == 2) {
        const listUrl = [
          '/system/mobileLogin',
          '/system/login',
          '/system/sliderCode/valid', // 滑块
          '/system/sliderCode/create', // 获取图片验证码
          '/system/val/code/mobile/create', // 短信验证码
          '/system/user/pwd/retrievePassword', // 修改找回密码
          '/service/web/company/user/registered', // 注册
          '/system/mobile/valCode/valid' // 校验手机验证码
        ]
        if (listUrl.includes(url)) {
          Message.warning('系统关闭中')
        } else {
          if (!window.sessionStorage.getItem('token')) {
            return false
          }
        }
        window.sessionStorage.clear()
        window.sessionStorage.setItem('state', 2)
        return router.replace({ path: '/login' })
      }
    }
    const res = await axios.post(url, params, paramsA)
    return typeof res !== 'undefined' && res
  } catch (err) {
    return Message.error(err.message)
  }
}

export async function get (url, params) {
  try {
    const res = await axios.get(url, { params: params })
    return typeof res !== 'undefined' && res
  } catch (err) {
    return Message.error(err.message)
  }
}

// 下载文件
export async function downloadFile (url, params) {
  try {
    const res = await axios({
      method: 'post',
      url,
      data: params,
      responseType: 'blob'
    })
    return typeof res !== 'undefined' && res
  } catch (err) {
    console.log(err)
    return Message.error(err.message)
  }
}
